import React, { useContext } from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import placeHolderImage from '../../images/placeholder.png'
import { formatPrice } from '../../utils/format-price'
import { getMetafield } from '../../utils/get-metafield'
import { GlobalDispatchContext } from '../../contexts/GlobalContextProvider'

const ProductMetaWrap = styled.div`
  ${tw`pt-3 pb-6 px-3 flex text-colekt-dark-gray`}
  font-size: 0.6rem;
`

const ProductMeta = styled('div')`
  ${tw`flex-auto`}
`
const ProductPriceWrap = styled.div`
  ${tw`flex-shrink font-extended uppercase tracking-wider leading-tight ml-2`}
  margin-top: -0px;
`

const Title = styled.h2`
  ${tw`font-extended uppercase tracking-wider leading-tight mb-1`}
  font-weight: 400;
`

const ProductShortDescription = styled.div`
  ${tw`font-mono tracking-wider `}
  padding-left: 0px !important;
`

const Price = styled.div`
  ${tw`text-right inline-block`}
  &:nth-of-type(2) {
    margin-left: 10px;
  }
`

const ProductCardSmall = ({ list, position, product, isSmall }) => {
  const dispatch = useContext(GlobalDispatchContext)

  const { featuredImage, title, metafields, variants, slug, priceRangeV2 } = product

  const handleTrackingData = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'eec.productClick',
      ecommerce: {
        click: {
          products: [
            {
              id: variants[0].sku,
              name: title,
              position,
            },
          ],
        },
        setAction: {
          list,
        },
      },
    })
  }

  const handleClick = () => {
    handleTrackingData()

    dispatch({ type: 'TOGGLE_CART' })
  }

  const minVariantPrice = formatPrice(priceRangeV2.minVariantPrice.currencyCode, priceRangeV2.minVariantPrice.amount)

  const maxVariantPrice = formatPrice(priceRangeV2.maxVariantPrice.currencyCode, priceRangeV2.maxVariantPrice.amount)

  const image = getImage(featuredImage?.localFile)

  const shortDescription = getMetafield(metafields, 'subtitle')

  return (
    <Link
      to={slug}
      onClick={() => {
        handleClick()
      }}
      className="block hover:opacity-90 transition-all duration-50"
    >
      {featuredImage ? (
        <GatsbyImage
          objectFit="cover"
          loading="lazy"
          alt={image.altText ? image.altText : `Product Image of ${title}`}
          image={image}
        />
      ) : (
        <img alt="placeholder" src={placeHolderImage} />
      )}
      <ProductMetaWrap isSmall>
        <ProductMeta>
          <Title isSmall>{title}</Title>
          <ProductShortDescription isSmall>{shortDescription}</ProductShortDescription>
        </ProductMeta>
        <ProductPriceWrap isSmall>
          <Price>
            {minVariantPrice === maxVariantPrice ? minVariantPrice : `${minVariantPrice} - ${maxVariantPrice}`}
          </Price>
        </ProductPriceWrap>
      </ProductMetaWrap>
    </Link>
  )
}

export default ProductCardSmall

ProductCardSmall.propTypes = {
  list: PropTypes.string,
  position: PropTypes.number,
  product: PropTypes.object.isRequired,
  isSmall: PropTypes.bool,
}
